import { Title } from '../title';
import { Button } from '@/components/common';
import AppRoutes from '@/const/routes';

export const GetStartedAlt: React.FC = () => {
	return (
		<div className="py-14 lg:py-12 xl:py-0 relative">
			<div
				className="lg:bg-[url('/img/landing/svg/wizar-lines.svg')] bg-contain
        2xl:bg-contain bg-no-repeat bg-center min-h-[250px] lg:h-[387px] xl:h-[573px] 2xl:min-h-[650px]
        flex justify-center"
			>
				<div className="flex flex-col items-center justify-center lg:mt-24 xl:mt-24">
					<Title
						description="See if you qualify—it's fast, easy and free"
						className="md:mt-4 gap-8"
						typographyDescription="regular-28"
						classNameDescription={'!text-[30px]'}
					>
						<span className="text-primary">Claim</span> What&apos;s Yours
					</Title>
					<Button
						decoration="primary"
						size="large"
						className="mt-9"
						href={AppRoutes.LANDING_CASES}
						isTargetBlack
					>
						Get Started Today
					</Button>
				</div>
			</div>
		</div>
	);
};
